import type { Sprite } from '../spriteLayout';


// WHY: NEVER slice the atlas into a canvas — iOS WebKit purges retained canvases (bodies vanish, guns float)
const srcW = (sp: Sprite): number => sp.sw ?? sp.canvas.width;
const srcH = (sp: Sprite): number => sp.sh ?? sp.canvas.height;

export function drawSprite(
  ctx: CanvasRenderingContext2D, sp: Sprite, dx: number, dy: number, dw?: number, dh?: number,
): void {
  const sw = srcW(sp), sh = srcH(sp);
  ctx.drawImage(sp.canvas, sp.sx ?? 0, sp.sy ?? 0, sw, sh, dx, dy, dw ?? sw, dh ?? sh);
}

export function drawSpriteBox(
  ctx: CanvasRenderingContext2D, sp: Sprite, dx: number, dy: number, dw: number, dh: number,
): void {
  ctx.drawImage(sp.canvas, (sp.sx ?? 0) + sp.bx, (sp.sy ?? 0) + sp.by, sp.bw, sp.bh, dx, dy, dw, dh);
}
